import { useEffect, useState } from 'react';
import { reverseGeocodeMapbox } from '../utils/mapbox';

function needsResolve(addr) {
  if (!addr || addr.length <= 3) return true;
  if (/^-?\d+\.?\d*,\s*-?\d+\.?\d*$/.test(addr)) return true;
  if (addr.toLowerCase().includes('flagdown')) return true;
  return false;
}

export default function ResolvedAddress({ address, lat, lon, fallback = '—' }) {
  const addr = typeof address === 'string' ? address.trim() : '';
  const [resolved, setResolved] = useState(needsResolve(addr) ? null : addr);

  useEffect(() => {
    if (!needsResolve(addr)) {
      setResolved(addr);
      return;
    }
    const numLat = parseFloat(lat);
    const numLon = parseFloat(lon);
    if (!Number.isFinite(numLat) || !Number.isFinite(numLon)) {
      setResolved(addr || fallback);
      return;
    }
    let cancelled = false;
    reverseGeocodeMapbox(numLat, numLon).then((result) => {
      if (!cancelled) setResolved(result || addr || fallback);
    });
    return () => { cancelled = true; };
  }, [addr, lat, lon, fallback]);

  if (resolved === null) return <span className="secondary">Resolving…</span>;
  return <>{resolved}</>;
}
